exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".invoiceThirdStep-2c845{display:flex;justify-content:center;align-items:center}", ""]);

// Exports
exports.locals = {
	"invoiceThirdStep": "invoiceThirdStep-2c845"
};